import { render, staticRenderFns } from "./SearchbtnPhone.vue?vue&type=template&id=a38f6152&"
import script from "./SearchbtnPhone.vue?vue&type=script&lang=js&"
export * from "./SearchbtnPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports